"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
class ParentNotFoundError extends client_library_1.ExtendableError {
    constructor() {
        super(`Parent not found`);
    }
}
exports.default = ParentNotFoundError;
//# sourceMappingURL=ParentNotFoundError.js.map